import React from 'react';
import PropTypes from 'prop-types';
import * as LoaderComponent from 'react-loaders';
// eslint-disable-next-line import/no-webpack-loader-syntax
import '!style-loader!css-loader!loaders.css/loaders.min.css';
import './Loader.scss';

const Loader = ({ className, fullScreen, ...props }) => (
	<LoaderComponent.Loader
		type="ball-scale-ripple-multiple"
		{...props}
		className={`${className} ${fullScreen ? 'full-screen' : ''}`}
	/>
);

Loader.defaultProps = {
	type: 'ball-scale-ripple-multiple',
	active: false,
	fullScreen: false,
	color: '',
	className: '',
	innerClassName: '', // applied to the same div as .loader-inner.${type}
	// useful for advanced styling
	// className & style are implied
};

Loader.propTypes = {
	type: PropTypes.string,
	active: PropTypes.bool,
	fullScreen: PropTypes.bool,
	color: PropTypes.string,
	className: PropTypes.string,
	innerClassName: PropTypes.string, // applied to the same div as .loader-inner.${type}
	// useful for advanced styling
	// className & style are implied
};

export default Loader;
